<template>
  <LoginWrapper>
    <div class="box">
      <div class="box_title">
        <h2>비밀번호 찾기</h2>
      </div>
      <div class="search_tab">
        <ul class="mx-auto">
          <li class="input_wrap chk_round">
            <div class="text_label">
              <label>
                <input
                  v-model="recoverBy"
                  type="radio"
                  name="recoverByPhone"
                  class="chk_agree"
                  checked=""
                  value="phone"
                />
                <em></em>
                <span>휴대폰 번호로 찾기</span>
              </label>
            </div>
            <p class="guide_txt">
              본인 인증을 통해 가입된 계정이 있는 경우, <br />
              카카오톡으로 임시 비밀번호를 보내드립니다.
            </p>
          </li>
        </ul>
      </div>
      <ul class="tab_wrap">
        <li>
          <ul class="form_wrap">
            <li class="btn_wrap">
              <button class="box_btn" @click="findPassword">
                <span class="an_t">본인 인증</span>
              </button>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <Iamport />
    <!-- ERROR MODAL START -->
    <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
      <Modal v-if="showErrorModal" @close="toggleErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_inner">
              <p style="white-space: pre-line;">
                {{ errorMessage }}
              </p>
              <div
                v-if="
                  errorMessage.includes(
                    '입력하신 정보로 가입된 계정을 찾을 수 없습니다.'
                  )
                "
                class="btnWrap"
              >
                <button
                  class="box_btn w-full alert clr"
                  @click="toggleErrorModal"
                >
                  <span class="an_t">닫기</span>
                </button>
                <router-link to="/join/sign_up" class="box_btn w-full alert pd">
                  <span class="an_t">회원가입 하러 가기</span>
                </router-link>
              </div>
              <div v-else class="btnWrap">
                <button class="box_btn w-full alert" @click="closeErrorModal">
                  <span class="an_t">{{
                    isFindPassword ? '로그인' : '확인'
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <!-- ERROR MODAL END -->
    </transition>
  </LoginWrapper>
</template>
<script>
import LoginWrapper from '@/components/auth/LoginWrapper.vue'
import { v4 as uuidv4 } from 'uuid'
import { AUTH_REQUEST_TEMPORARY_PASSWORD } from '@/store/types'

export default {
  name: 'PasswordLost',
  components: { LoginWrapper },
  data() {
    return {
      recoverBy: 'phone',
      phone: '',
      email: '',
      loginId: '',
      loginNm: '',
      showErrorModal: false,
      isFindPassword: false,
      errorMessage: ''
    }
  },
  methods: {
    generateMerchantId() {
      return `ORD-${uuidv4()}`
    },
    toggleErrorModal(errorMessage, isFindPassword) {
      this.errorMessage = errorMessage
      this.showErrorModal = !this.showErrorModal
      this.isFindPassword = isFindPassword
    },
    closeErrorModal() {
      this.showErrorModal = !this.showErrorModal
      if (this.isFindPassword) {
        this.$router.push({ name: 'login' })
      }
    },
    startPhoneAuth() {
      const info = {
        findTp: this.recoverBy
      }
      window.IMP.certification(
        {
          merchant_uid: this.generateMerchantId(),
          popup: true
        },
        async (rsp) => {
          if (rsp.success) {
            info.impUid = rsp.imp_uid
            try {
              const response = await this.$store.dispatch(
                AUTH_REQUEST_TEMPORARY_PASSWORD,
                info
              )
              console.log(response)
              const providers = response.data.result?.authentication?.providers
              console.log(providers)
              if (providers) {
                const providersLength =
                  providers.length === 2
                    ? '카카오, 네이버'
                    : providers.includes('kakao')
                    ? '카카오'
                    : providers.includes('naver')
                    ? '네이버'
                    : ''
                this.toggleErrorModal(
                  `해당 계정은 ${providersLength} 계정으로 가입되었습니다 \n SNS 계정으로 로그인해 주세요.`,
                  true
                )
              } else {
                this.toggleErrorModal(
                  '임시 비밀번호를 휴대폰으로 보냈습니다.',
                  true
                )
              }
            } catch (err) {
              // that.toggleErrorModal('Error')
              this.toggleErrorModal(
                // `[${err.response.data.errorState.code}] ${err.response.data.errorState.message}`,
                // false
                `${err.response.data.errorState.message}`,
                false
              )
            }
          } else {
            this.toggleErrorModal(rsp.error_msg)
          }
        }
      )
    },
    async findPassword() {
      if (this.recoverBy === 'phone') {
        this.startPhoneAuth()
      } else {
        const info = {
          findTp: this.recoverBy,
          email: btoa(this.email),
          loginNm: this.loginNm
        }
        try {
          await this.$store.dispatch(AUTH_REQUEST_TEMPORARY_PASSWORD, info)
          this.toggleErrorModal(
            '임시 비밀번호를 이메일 [' + this.email + '] 로 보냈습니다.',
            true
          )
        } catch (err) {
          // this.toggleErrorModal('Error')
          this.toggleErrorModal(
            // `[${err.response.data.errorState.code}] ${err.response.data.errorState.message}`,
            // false
            `${err.response.data.errorState.message}`,
            false
          )
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.ly_inner {
  padding: 52px 65px 52px 65px;
  p {
    text-align: center;
  }
}
[data-detail*='id_search'] .tab_wrap > li {
  height: auto;
}
[data-detail*='id_search'] .tab_wrap {
  margin-top: 13px;
}
.box_title {
  margin-bottom: 25px;
}
.box_wrap .box + .box {
  position: relative;
  padding: 40px 56px 0px 56px;
  margin-top: 40px;
  border-top: 1px solid #d6e7f1;
}
.form_wrap > li + li {
  margin-top: 20px;
}
.input_wrap + .btn_wrap {
  margin-top: 2em;
}
[data-detail*='id_search'] .text_wrap {
  margin-top: 1em;
}
.input_wrap {
  input[type='radio'] {
    width: 24px;
    height: 24px;
    top: 4px;
    left: 0;
  }
}
.box_wrap {
  padding: 0px 0;
  overflow-y: hidden;
}
html {
  overflow-y: none;
}
.box_btn {
  transition: all 0.5s;
  opacity: 1;
  color: #ffffff;
}
.box_btn_disabeld {
  opacity: 0.5;
  cursor: default;
}
[data-detail*='id_search'] .search_tab .text_label {
  width: 100%;
}
[data-detail*='id_search'] .search_tab .text_label label {
  padding: 0;
  display: flex;
  justify-content: center;
  input {
    border-radius: 100%;
  }
  span {
    margin-left: 5px;
  }
}
[data-detail*='id_search'] .search_tab .text_label input + em {
  position: relative;
  top: 0;
  left: 0;
}
.box_btn .an_t {
  font-family: 'pretendard-medium';
  font-weight: 600;
  font-size: 18px;
  line-height: 56px;
  letter-spacing: 0;
}
.btnWrap {
  display: flex;
  justify-content: center;
  gap: 20px;
  .box_btn.clr {
    background-color: #fff;
    border: 1px solid #008df3;
    span {
      color: #008df3;
    }
  }
}
</style>
